<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card class="rounded-xl elevation-3">
      <!-- Topo com busca -->
      <v-toolbar flat dense>
        <v-toolbar-title class="text-subtitle-1 font-weight-medium">
          Selecionar equipamento
        </v-toolbar-title>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Pesquisar"
          dense
          clearable
          hide-details
          class="max-w-search"
          solo-inverted
          flat
        />
      </v-toolbar>

      <div class="px-4 pt-2 d-flex align-center">
        <v-switch
          v-model="incluirInativos"
          label="Exibir inativos"
          class="mt-0"
          hide-details
          :disabled="loading"
          @change="carregarEquipamentos"
        />
      </div>

      <!-- Conteúdo com altura controlada -->
      <v-card-text>
        <v-container fluid>
          <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
              <v-data-table
                :headers="headers"
                :items="filteredList"
                :loading="loading"
                loading-text="Buscando dados..."
                :search="search"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:footer></template>
                <!-- Coluna de ação (plus) -->
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        type="button"
                        v-bind="attrs"
                        v-on="on"
                        @click="addEquipamento(item)"
                      >
                        <v-icon
                          :color="'green'"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar equipamento</span>
                  </v-tooltip>
                </template>

                <!-- Coluna nome centralizada verticalmente -->
                <template v-slot:item.centroCusto="{ item }">
                  <div class="d-flex align-center">
                    <span class="text-truncate">{{ item.centroCusto }}</span>
                    <v-chip
                      v-if="!item.ativo"
                      x-small
                      color="grey"
                      text-color="white"
                      class="ml-2"
                    >
                      Inativo
                    </v-chip>
                  </div>
                </template>

                <!-- Estado vazio -->
                <template v-slot:no-data>
                  <div v-if="loading" class="text-center pa-6">
                    Carregando equipamentos...
                  </div>
                  <div
                    v-else-if="carregamentoRealizado && filteredList.length === 0"
                    class="text-center pa-6"
                  >
                    Nenhum equipamento disponivel.
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import { obterEquipamentosSelecaoAsync } from "../../../services/equipamentoService";

export default {
  name: "equipamento",
  data: () => ({
    search: "",
    valid: true,
    errorMessage: false,
    equipamentos: [],
    loading: false,
    carregamentoRealizado: false,
    incluirInativos: false,
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false,
        width: 72,
        align: "center",
      },
      {
        text: "Id",
        align: "start",
        value: "id",
      },
      { text: "Equipamento", value: "centroCusto", sortable: true },
    ],
  }),
  props: {
    equipamentoL: Array,
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    equipamentosAdicionados() {
      return this.equipamentoL.map((e) => e.idEquipamento);
    },
    filteredList() {
      const q = (this.search || "").trim().toLowerCase();
      return (this.equipamentos || []).filter((e) => {
        const correspondeBusca =
          e.id?.toString().includes(q) ||
          (e.centroCusto || "").toLowerCase().includes(q) ||
          (e.prefixo || "").toLowerCase().includes(q);

        return correspondeBusca && !this.equipamentosAdicionados.includes(e.id);
      });
    },
  },
  methods: {
    async carregarAoAbrir() {
      this.search = "";
      this.incluirInativos = false;
      await this.carregarEquipamentos();
    },
    async carregarEquipamentos() {
      this.loading = true;
      this.carregamentoRealizado = false;
      this.equipamentos = [];

      try {
        const equipamentos = await obterEquipamentosSelecaoAsync(
          this.incluirInativos
        );

        this.equipamentos = equipamentos || [];
      } catch (erro) {
        this.equipamentos = [];
        this.$store.dispatch("ui/showSnackbar", {
          text: "Não foi possível carregar os equipamentos.",
          color: "error",
          timeout: 4000,
        });
      } finally {
        this.carregamentoRealizado = true;
        this.loading = false;
      }
    },
    updateObjectEstate() {
      return this.$refs.form.validate();
    },
    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    addEquipamento(e) {
      try {
        if (!e || !e.id) {
          throw new Error("Equipamento inválido.");
        }

        const equipamento = {
          idEquipamento: e.id,
          centroCusto: e.centroCusto,
          index:
            this.equipamentoL.length === 0
              ? 0
              : this.equipamentoL[this.equipamentoL.length - 1].index + 1,
        };
        this.equipamentoL.push(JSON.parse(JSON.stringify(equipamento)));
        this.$store.dispatch("ui/showSnackbar", {
          text: "Equipamento adicionado ao plano.",
          color: "success",
          timeout: 2500,
        });
      } catch (erro) {
        this.$store.dispatch("ui/showSnackbar", {
          text: erro?.message || "Não foi possível adicionar o equipamento ao plano.",
          color: "error",
          timeout: 3000,
        });
      }
    },
  },
};
</script>

<style scoped>
/* Limita a largura do campo de busca no topo */
.max-w-search {
  max-width: 360px;
}

/* Tabela com 2 colunas bem definidas */
.two-col-table >>> th:nth-child(1),
.two-col-table >>> td:nth-child(1) {
  text-align: center !important;
  width: 72px !important;
  white-space: nowrap;
}

.two-col-table >>> th:nth-child(2),
.two-col-table >>> td:nth-child(2) {
  /* deixa o nome respirar e truncar com reticências */
  max-width: 100%;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
